export default [
  {
    name: "aboutMiiHeadModel",
    type: "gltfModel",
    path: "models/AboutMiiHead/aboutMiiHead.glb",
  },
  {
    name: "aboutMiiHeadBlinkModel",
    type: "gltfModel",
    path: "models/AboutMiiHead/aboutMiiHeadBlink.glb",
  },
  {
    name: "aboutMiiHeadPinchModel",
    type: "gltfModel",
    path: "models/AboutMiiHead/aboutMiiHeadPinch.glb",
  },
  {
    name: "crystalTexture",
    type: "texture",
    path: "textures/crystalTexture.jpg",
  },
];
